import * as actions from 'actions';

export default (values, dispatch, props, currentField) => {
  if (!currentField || values[currentField] === '') return Promise.resolve();

  return new Promise((resolve, reject) => {
    dispatch(actions.f2fFieldValidate(currentField, values[currentField], resolve, reject));
  });
};



/** WEBPACK FOOTER **
 ** ./src/members/Main/Referral/ReferralForm/asyncValidate.js
 **/